import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLineInView } from "./Reveal";
import { scrollToId as scrollTo } from "@/lib/scroll";

const STEPS = [
  {
    n: "01",
    title: "Anfrage senden",
    text: "Sie erzählen uns kurz von Ihrem Unternehmen und Ihren Vorstellungen – ganz unverbindlich.",
  },
  {
    n: "02",
    title: "Wir erstellen Ihre Website",
    text: "Wir kümmern uns um Gestaltung und technische Umsetzung – passend zu Ihrem Unternehmen.",
  },
  {
    n: "03",
    title: "Wir bringen Sie online",
    text: "Wir übernehmen Domain, Hosting und Veröffentlichung. Danach betreuen wir Ihren Webauftritt entsprechend Ihres Pakets weiter.",
  },
];

export default function Process() {
  return (
    <section id="ablauf" className="relative py-14 lg:py-20 border-t border-white/10" data-testid="process">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div>
            <Reveal className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-6 flex items-center gap-3">
              <span className="h-px w-10 bg-[#FF3B00]" /> So einfach geht's
            </Reveal>
            <h2 className="font-display text-4xl md:text-6xl leading-[0.98] tracking-tight text-white uppercase">
              <MaskLineInView>In 3 Schritten</MaskLineInView>
              <MaskLineInView delay={0.1}>zu Ihrer Website</MaskLineInView>
            </h2>
          </div>
          <Reveal delay={0.2}>
            <button
              onClick={() => scrollTo("#kontakt")}
              className="group inline-flex items-center gap-2 bg-[#FF3B00] text-white font-tech text-sm uppercase tracking-[0.12em] px-7 py-4 hover:bg-[#FF5C2B] active:scale-95 transition-all duration-200"
              data-testid="process-cta"
            >
              Jetzt unverbindlich anfragen
              <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group relative bg-[#100b07] p-8 lg:p-10 min-h-[240px] flex flex-col hover:bg-[#0F0F0F] transition-colors duration-300"
              data-testid={`process-step-${i}`}
            >
              <span className="font-display text-6xl lg:text-7xl text-neutral-800 group-hover:text-[#FF3B00] transition-colors duration-500">
                {s.n}
              </span>
              <div className="mt-auto">
                <h3 className="font-display text-2xl text-white mb-3">{s.title}</h3>
                <p className="text-neutral-400 text-sm leading-relaxed">{s.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
